export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Wip 1_04.dd66a0f6.jpg";